import SparkMD5 from "spark-md5";

export const computeMD5Checksum = async (file: File) => {
  const spark = SparkMD5.ArrayBuffer.hash(await file.arrayBuffer());
  return hexToBase64(spark);
};

// Utility functions for hex <-> bytes conversion
function hexToBytes(hex: string) {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = Number.parseInt(hex.substring(i, i + 2), 16);
  }
  return bytes;
}

// Convert binary string to base64
function binaryToBase64(binary: string) {
  return btoa(binary);
}
// Convert hex to base64
function hexToBase64(hexString: string) {
  const bytes = hexToBytes(hexString);
  const binaryString = Array.from(bytes)
    .map((byte) => String.fromCharCode(byte))
    .join("");
  return binaryToBase64(binaryString);
}
